import React from 'react';
import { useAuthState, AuthContextProps } from '../context/AuthContext';

const withAuth = <T extends AuthContextProps = AuthContextProps>(
  ComponentToWrap: React.ComponentType<T>
): React.FC<T & AuthContextProps> => {
  const WithAuthContext = (props: Omit<T, keyof AuthContextProps>) => {
    const authContext = useAuthState();
    return <ComponentToWrap {...authContext} {...(props as T)} />;
  };

  WithAuthContext.displayName = 'withAuthContext';

  return WithAuthContext;
};

export default withAuth;
